import { FinalGradientGraphicVariables } from 'sigma-mappings';

// Ids de Tipo de Dados por Enrolamento para o gráfico, constantes na API.
const finalGradientGraphicIds = {
  winding1: {
    [FinalGradientGraphicVariables.TRANSFORMER_OIL_TEMPERATURE]: 'bc6369d5-67b7-4510-bca4-93ab7cc905b2',
    [FinalGradientGraphicVariables.WINDING_TEMPERATURE]: 'a3ad6355-2839-4b82-808f-869a6aedabb4',
    [FinalGradientGraphicVariables.FINAL_WINDING_TEMPERATURE]: '0398fe25-3b41-4f8e-a10c-8f67665013de',
    [FinalGradientGraphicVariables.ALARM_TEMPERATURE]: 'df1718e7-9803-4647-9f39-c39f1ecfcbb5',
    [FinalGradientGraphicVariables.SHUTDOWN_TEMPERATURE]: '1c665837-a13b-499f-a8f6-ffbe655b2a68',
  },
  winding2: {
    [FinalGradientGraphicVariables.TRANSFORMER_OIL_TEMPERATURE]: 'bc6369d5-67b7-4510-bca4-93ab7cc905b2',
    [FinalGradientGraphicVariables.WINDING_TEMPERATURE]: 'a9430589-f865-4702-ad46-336eacc14d24',
    [FinalGradientGraphicVariables.FINAL_WINDING_TEMPERATURE]: '690e66e7-fbd3-4d7b-aa71-883dd3b2a675',
    [FinalGradientGraphicVariables.ALARM_TEMPERATURE]: 'e5f4bf69-d15d-4721-b0d5-84879dff8be0',
    [FinalGradientGraphicVariables.SHUTDOWN_TEMPERATURE]: '2631a3dd-c957-433e-83a2-91811b3b77c9',
  },
  winding3: {
    [FinalGradientGraphicVariables.TRANSFORMER_OIL_TEMPERATURE]: 'bc6369d5-67b7-4510-bca4-93ab7cc905b2',
    [FinalGradientGraphicVariables.WINDING_TEMPERATURE]: 'b900e28f-abfb-4551-8877-2852f011dbb7',
    [FinalGradientGraphicVariables.FINAL_WINDING_TEMPERATURE]: 'f1a7e2be-bf7c-4e71-9d62-20b2e6660f37',
    [FinalGradientGraphicVariables.ALARM_TEMPERATURE]: 'e95aba5e-7dd4-44bf-897c-fe70c056c081tim',
    [FinalGradientGraphicVariables.SHUTDOWN_TEMPERATURE]: '36408b64-03f6-407d-9d98-a7a51f7310a0',
  },
};

export default finalGradientGraphicIds;
